import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

export function renderTerms(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero mkt-page-hero-legal">
        <h1>Terms &amp; Conditions</h1>
        <p>Last updated: 15 July 2026</p>
      </section>

      <section class="mkt-section mkt-prose">
        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use of Simustage
          (the "Service"), operated as described on this website. By creating an account or
          using the Service, you agree to these Terms. If you do not agree, please do not use
          the Service.
        </p>

        <h2>1. Accounts</h2>
        <p>
          You must provide accurate information when creating an account and are responsible
          for keeping your login credentials secure. You are responsible for all activity that
          occurs under your account.
        </p>

        <h2>2. Use of the Service</h2>
        <p>
          Simustage lets you create interactive courses, simulations, and quizzes. You agree
          not to use the Service to create or share content that is unlawful, infringing,
          harmful, or that violates the rights of others. We may suspend or terminate accounts
          that violate these Terms.
        </p>

        <h2>3. Your content</h2>
        <p>
          You retain ownership of the courses and topics you create. By using the Service, you
          grant us a limited license to host, store, and display your content solely to operate
          and provide the Service to you.
        </p>

        <h2>4. Wallet, generation &amp; purchases</h2>
        <p>
          Creating content and buying another user's listing in the Library are paid for
          from your in-app wallet, which you top up through our payment processor, Razorpay, in
          amounts you choose. Wallet recharges are non-refundable except as described in our
          <a href="#/refund">Refund &amp; Cancellation Policy</a>.
        </p>

        <h2>5. Monthly viewing access</h2>
        <p>
          Viewing your own generated content, anything you have purchased, and free listings
          requires an active viewing period. Every new account receives one free 30-day period
          from signup; after that, ₹100/month (inclusive of taxes), or the amount shown on our
          <a href="#/pricing">Pricing</a> page, is automatically debited from your wallet balance
          every 30 days to keep viewing active. If your wallet balance is insufficient when a
          charge is due, viewing is paused — nothing is deleted — until you recharge and the
          charge succeeds. Prices may change with advance notice.
        </p>

        <h2>6. Usage limits</h2>
        <p>
          The Service may include usage limits (such as number of active courses or generation
          requests). We may adjust these limits from time to time to keep the Service
          sustainable for everyone.
        </p>

        <h2>7. Availability</h2>
        <p>
          We aim to keep the Service available and reliable but do not guarantee uninterrupted
          access. Features may change, and we may modify or discontinue parts of the Service
          with reasonable notice.
        </p>

        <h2>8. Limitation of liability</h2>
        <p>
          The Service is provided "as is" without warranties of any kind. To the fullest extent
          permitted by law, we are not liable for indirect, incidental, or consequential damages
          arising from your use of the Service.
        </p>

        <h2>9. Termination</h2>
        <p>
          You may stop using the Service and delete your account at any time from Settings. We
          may suspend or terminate access for violations of these Terms.
        </p>

        <h2>10. Changes to these Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the Service after an
          update constitutes acceptance of the revised Terms.
        </p>

        <h2>11. Contact</h2>
        <p>
          Questions about these Terms can be sent to
          <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>.
        </p>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/terms', signedIn, body);
}
